import React, { useRef } from 'react';
import SearchIcon from '@assets/icons/search.svg';
import { ActivityIndicator } from './activity-indicator';
import { TextInput as BaseTextInput, TouchableOpacity } from 'react-native';
import { createStyles } from '@/contexts/theme-context';
import { TextInput, Props as TextInputProps } from './text-input';

export type Props = TextInputProps & {
  isLoading?: boolean;
  searchIconColor?: string;
};

const SEARCH_ICON_HIT_SLOP = {
  bottom: 8,
  left: 16,
  right: 0,
  top: 8,
};

export const SearchInput: React.FC<Props> = ({
  isLoading = false,
  rightElement,
  searchIconColor,
  inputRef,
  ...rest
}) => {
  const [styles, theme] = useStyles();
  const overrideInputRef = useRef<BaseTextInput>(null);

  const iconColor = searchIconColor || theme.colors.inactiveFill;
  const finalInputRef = inputRef || overrideInputRef;
  const { editable = true, onPress } = rest;

  return (
    <TextInput
      autoCapitalize="none"
      autoComplete="off"
      clearButtonMode={isLoading ? undefined : 'while-editing'}
      containerStyle={styles.container}
      inputRef={finalInputRef}
      leftElement={
        <TouchableOpacity
          activeOpacity={1}
          hitSlop={SEARCH_ICON_HIT_SLOP}
          onPress={() => {
            if (editable) {
              finalInputRef.current?.focus();
            } else {
              onPress?.();
            }
          }}
        >
          <SearchIcon fill={iconColor} />
        </TouchableOpacity>
      }
      returnKeyType="search"
      rightElement={isLoading ? <ActivityIndicator /> : rightElement}
      {...rest}
    />
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.colors.background,
  },
}));
